import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogFooter } from "@ui/dialog";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import TranslatedText from "@components/items/display/TranslatedText";
import { useB2B } from "@modules/content/B2BContext";

const ANNOUNCEMENT_KEY = "last_seen_announcement";

export function AnnouncementPopup() {
  const { b2B } = useB2B();
  const currentText = b2B?.data?.[0]?.announcementText;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    const lastSeenAnnouncement = localStorage.getItem(ANNOUNCEMENT_KEY);
    if (currentText && currentText !== lastSeenAnnouncement) {
      setOpen(true);
    }
  }, [currentText]);

  const handleDismiss = () => {
    if (currentText) {
      localStorage.setItem(ANNOUNCEMENT_KEY, currentText);
    }
    setOpen(false);
  };

  if (!currentText) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(state) => {
        if (!state) handleDismiss();
      }}
    >
      <DialogContent className="flex flex-col items-center justify-center gap-5 bg-white p-8 text-center text-[20px] font-medium sm:max-w-[635px] dark:bg-[#010D19] dark:text-white [&>button]:hidden">
        <div>{currentText}</div>
        <DialogFooter>
          <ShadcnButton
            onClick={handleDismiss}
            className="text-white focus-visible:ring-0 focus-visible:ring-offset-0 dark:bg-[#64A6E1] hover:dark:bg-[#64A6E1]"
          >
            <TranslatedText text="layout.approve" />
          </ShadcnButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
